var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/User/Account") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/User/Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C5.925,1 1,5.925 1,12 C1,18.075 5.925,23 12,23 C18.075,23 23,18.075 23,12 C23,5.925 18.075,1 12,1 Z M12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 Z M12,11.541 C13.933,11.541 15.5,9.974 15.5,8.041 C15.5,6.108 13.933,4.541 12,4.541 C10.067,4.541 8.5,6.108 8.5,8.041 C8.5,9.974 10.067,11.541 12,11.541 Z M12,5.541 C13.378,5.541 14.5,6.663 14.5,8.041 C14.5,9.419 13.378,10.541 12,10.541 C10.622,10.541 9.5,9.419 9.5,8.041 C9.5,6.663 10.622,5.541 12,5.541 Z M12,12.557 L12,12.557 C9.912,12.557 7.955,13.575 6.758,15.286 L5.055,17.719 C5.272,17.982 5.508,18.229 5.753,18.466 L7.577,15.86 C8.586,14.419 10.24,13.558 12,13.558 C13.76,13.558 15.413,14.419 16.422,15.86 L18.246,18.466 C18.491,18.229 18.727,17.983 18.944,17.719 L17.241,15.287 C16.044,13.575 14.088,12.557 12,12.557 Z",
    id: "Shape",
    fill: "#00708D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.ae5ca88a135f0d2ba736e7da3012fb2b.svg";
export { ForwardRef as ReactComponent };